<template>
  <div data-testid="ar-dashboard-payment-plans">
    <v-card outlined class="outlined mb-6 elevation-0 rounded-lg" width="100%">
          <v-toolbar
      color="transparent"
      flat
      class="text-h5 mb-2 rounded-0 py-1"
    >
                <span>
                    Payment Plans:
                </span>
                <v-btn-toggle class="transparent pl-3">
                    <v-btn
                        data-testid="plan-view-active-btn"
                        class="plan-view-active-btn px-2 ma-0 text-h6 font-weight-regular"
                        depressed
                        :class="pagination.status === 'active' ? 'info--text' : ''"
                        @click="pagination.status = 'active'"
                    >
                        Active
                    </v-btn>
                    <v-btn
                        data-testid="plan-view-pending-btn"
                        class="plan-view-pending-btn px-2 ma-0 text-h6 font-weight-regular"
                        depressed
                        :class="pagination.status === 'pending' ? 'info--text' : ''"
                        @click="pagination.status = 'pending'"
                    >
                        Pending
                    </v-btn>
                    <v-btn
                        data-testid="plan-view-completed-btn"
                        class="plan-view-completed-btn px-2 ma-0 text-h6 font-weight-regular"
                        depressed
                        :class="pagination.status === 'completed' ? 'info--text' : ''"
                        @click="pagination.status = 'completed'"
                    >
                        Completed
                    </v-btn>
                    <v-btn
                        data-testid="plan-view-failed-btn"
                        class="plan-view-failed-btn px-2 ma-0 text-h6 font-weight-regular"
                        depressed
                        :class="pagination.status === 'failed' ? 'info--text' : ''"
                        @click="pagination.status = 'failed'"
                    >
                        Failed
                    </v-btn>
                    <v-btn
                        data-testid="plan-view-all-btn"
                        class="plan-view-all-btn px-2 ma-0 text-h6 font-weight-regular"
                        depressed
                        :class="pagination.status === '' ? 'info--text' : ''"
                        @click="pagination.status = ''"
                    >
                        View All
                    </v-btn>
                </v-btn-toggle>
        </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="paymentPlans.data"
        :loading="loading"
        :options.sync="pagination"
        :footer-props="{'items-per-page-options': pagination.itemsPerPageOptions}"
        :server-items-length="pagination.totalItems"
      >
        <template slot="item" slot-scope="props">
          <tr>
          <td data-testid="first-name">{{ props.item.first_name }}</td>
          <td data-testid="last-name">{{ props.item.last_name }}</td>
          <td data-testid="location-code">{{ props.item.facility.location_code }}</td>
          <td data-testid="unit-number">{{ props.item.unit.name }}</td>
          <td data-testid="phone">{{ addDashes(props.item.phone) }}</td>
          <td data-testid="next-payment-date">
            <span v-if="findNextPaymentInfo(props.item.payments).payment_date">
              {{ findNextPaymentInfo(props.item.payments).payment_date }}
            </span>
            <span v-else>Not Found</span>
          </td>
          <td
            data-testid="status"
            :class="statusCode(props.item.status)"
            style="text-transform: capitalize"
          >
            {{ props.item.status }}
          </td>
          <td data-testid="past-due">
            <span v-if="findNextPaymentInfo(props.item.payments).payment_amount">
              ${{ findNextPaymentInfo(props.item.payments).payment_amount.toFixed(2) }}
            </span>
            <span v-else>Not Found</span>
          </td>
          <td class="pa-0">
            <v-btn
              data-testid="plan-view-payment-btn"
              class="plan-view-payment-btn primary"
              small
              @click="viewPaymentPlan(props.item)"
            >
              View Payment Plan
            </v-btn>
          </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <application-modal v-model="showPlanInfo" @collapse="hidePaymentPlan" width="65%">
      <div slot="modal-title">Payment Plan Information</div>
      <div slot="modal-body">
        <plan-info v-if="selectedPlan" :selectedPlan="selectedPlan" />
      </div>
      <span slot="cancel-text">Close</span>
      <div slot="create-button" />
    </application-modal>
  </div>
</template>

<script>
import ApplicationModal from "@/components/ApplicationModal";
import PlanInfo from "./PlanInfo";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "PlansTable",

  components: { PlanInfo, ApplicationModal },

  data() {
    return {
      headers: [
        {
          text: "First Name",
          value: "first_name",
          sortable: false
        },
        {
          text: "Last Name",
          value: "last_name",
          sortable: false
        },
        {
          text: "Facility",
          value: "facility"
        },
        {
          text: "Unit #",
          value: "unit_id",
          sortable: false
        },
        {
          text: "Phone Number",
          value: "phone",
          sortable: false
        },
        {
          text: "Next Payment Date",
          value: "next_payment_date"
        },
        {
          text: "Payment Status",
          value: "status",
          sortable: false
        },
        {
          text: "Payment Amount",
          value: "payment_amount"
        },
        {
          text: "Actions",
          sortable: false,
          class: "pl-2"
        }
      ],
      loading: false,
      pagination: {
        sortDesc: false,
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [5, 10, 25, 50],
        totalItems: 0,
        sortBy: ["location_code"],
        status: "active"
      },
      resendLoading: false,
      selectedPlan: null,
      showPlanInfo: false,
      updateEmail: false
    };
  },

  methods: {
    formatNextPaymentDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },

    viewPaymentPlan(selectedPlan) {
      this.selectedPlan = selectedPlan;
      this.showPlanInfo = true;
    },

    hidePaymentPlan() {
      this.selectedPlan = null;
      this.showPlanInfo = false;
    },

    statusCode(status) {
      if (status === "active" && this.darkMode) {
        return "white--text";
      } else if (status === "active" && !this.darkMode) {
        return "black--text";
      } else if (status === "pending") {
        return "yellow--text";
      } else if (status === "completed") {
        return "success--text";
      } else {
        return "error--text";
      }
    },

    handlePaymentPlanSearch() {
      this.loading = true;
      const searchPayload = {
        perPage: this.pagination.itemsPerPage,
        page: this.pagination.page,
        sortBy: this.pagination.sortBy[0],
        sortDirection: this.pagination.sortDesc ? "desc" : "asc"
      };
      if (this.pagination.status) {
        searchPayload.status = this.pagination.status;
      }

      this.$store.dispatch("searchPaymentPlans", searchPayload)
        .then((resp) => {
          this.pagination.totalItems = resp.data.payment_plans.total;
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },

    findNextPaymentInfo(payments) {
      if (payments.length) {
        const futurePayments = payments.filter(payment => moment(payment.payment_date).isAfter());
        const nearestFuturePayment = futurePayments[0];
        if (nearestFuturePayment && nearestFuturePayment.payment_amount && nearestFuturePayment.payment_date) {
          return {
            "payment_amount": nearestFuturePayment.payment_amount,
            "payment_date": moment(nearestFuturePayment.payment_date).format("dddd, MMMM Do YYYY")
          };
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    }
  },

  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme,
      paymentPlans: state => state.accountsReceivable.dashboardPaymentPlans
    })
  },

  watch: {
    pagination: {
      handler() {
        this.handlePaymentPlanSearch();
      },
      deep: true
    }
  },

  created() {
    this.handlePaymentPlanSearch();
  }
};
</script>
